import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { RWebShare } from "react-web-share";
import { Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { bindActionCreators } from "redux";
import Swal from "sweetalert2";
import { requestStoreList, requestStoreSave, requestGetStoreById, requestStoreUpdate, requestStoreDelete } from "../../Redux/actions";
import Footer from './../footer';
import PageHeader from './../header';
import Sidebar from './../Sidebar';
import '../../Admin/style.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
//import { DataTable, Header, HeaderRow, HeaderCell, Body, Row, Cell, } from '@table-library/react-table-library/table';
import DataTable from 'react-data-table-component';
import { addDegreeAdmin } from "../../Redux/sagas";

function StoreList(props) {
    const params = useParams();
    const [jobs, setjobs] = useState([]);
    // const [pagination, setpagination] = useState({});
    const navigate = useNavigate();
    const [pages, setpages] = useState([]);
    const [page_size, setpage_size] = useState(10);
    const [change, setchange] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [search, setSearch] = useState('');
    const [filter, setFilter] = useState([]);
    const [logindetails, setlogindetails] = useState({});
    const [statusdata, setstatusdata] = useState({ status: 0 });
    const [typingTimeout, setTypingTimeout] = useState(0);
    const [id, setid] = useState(0);
    const [addmodal, setaddModal] = useState(false);
    const [editmodal, seteditmodal] = useState(false);
    const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
    const [checked_all, setCheckedAll] = useState(false);
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [errorCategory, seterrorCategory] = useState("");
    const [errorDescription, seterrorDescription] = useState("");
    const [errorTaxRate, seterrorTaxRate] = useState("");
    const [errorCutOff, seterrorCutOff] = useState("");
    const [errorHSN, seterrorHSN] = useState("");
    const [adddata, setadddata] = useState({
        category: "", description: "", shortName: "", taxRate: 0, cutOff: 5, hsn: ""
    });
    const [editdata, seteditdata] = useState({
        category: "", description: "", shortName: "", taxRate: 0, cutOff: 5, hsn: ""
    });

    function validateEditHSN() {
        let formIsValid = false;
        if (!editdata.hsn) {
            formIsValid = false;
            seterrorHSN("*Enter HSN.");
        } else if (!/^\d{3}$/.test(editdata.hsn)) {
            formIsValid = false;
            seterrorHSN("*Enter valid HSN.");
        } else {
            formIsValid = true;
            seterrorHSN("");
        }
        return formIsValid;
    }

    function validateEditCutOff() {
        let formIsValid = false;
        if (!editdata.cutOff) {
            formIsValid = false;
            seterrorCutOff("*Enter cut off.");
        } else if (!/^\d{1,3}$/.test(editdata.cutOff)) {
            formIsValid = false;
            seterrorCutOff("*Enter valid cut off.");
        } else {
            formIsValid = true;
            seterrorCutOff("");
        }
        return formIsValid;
    }

    function validateEditTaxRate() {
        let formIsValid = false;
        console.log("Tax Rate:", editdata.taxRate);
        console.log("Type:", typeof editdata.taxRate);

        const taxRateStr = String(editdata.taxRate);  // Convert to string

        if (!taxRateStr) {
            seterrorTaxRate("*Enter tax rate.");
        } else if (!/^\d{1,3}$/.test(taxRateStr)) {
            seterrorTaxRate("*Enter valid tax rate (1 to 3 digits).");
        } else {
            formIsValid = true;
            seterrorTaxRate("");
        }

        return formIsValid;
    }

    function validateEditCategory() {
        let formIsValid = false;
        if (!editdata.category) {
            formIsValid = false;
            seterrorCategory("*Enter Category.");
        } else {
            formIsValid = true;
            seterrorCategory("");
        }
        return formIsValid;
    }

    function validateEditDescription() {
        let formIsValid = false;
        if (!editdata.description) {
            formIsValid = false;
            seterrorDescription("*Enter Description.");
        } else {
            formIsValid = true;
            seterrorDescription("");
        }
        return formIsValid;
    }

    function validateEditForm() {
        let hsn = validateEditHSN(); let cutoff = validateEditCutOff(); let taxRate = validateEditTaxRate(); let category = validateEditCategory(); let description = validateEditDescription();
        let valid = hsn && cutoff && taxRate && category && description;
        if (!valid) {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Please fill all the required fields correctly.",
            });
        }
        return valid;
    }

    function validateAddHSN() {
        let formIsValid = false;
        if (!adddata.hsn) {
            formIsValid = false;
            seterrorHSN("*Enter HSN.");
        } else if (!/^\d{3}$/.test(adddata.hsn)) {
            formIsValid = false;
            seterrorHSN("*Enter valid HSN.");
        } else {
            formIsValid = true;
            seterrorHSN("");
        }
        return formIsValid;
    }

    function validateAddCutOff() {
        let formIsValid = false;
        const str = String(adddata.cutOff);  // Convert to string

        if (!str) {
            seterrorCutOff("*Enter cut off.");
        } else if (!/^\d{1,3}$/.test(str)) {
            seterrorCutOff("*Enter valid cut off (1 to 3 digits).");
        } else {
            formIsValid = true;
            seterrorCutOff("");
        }
        return formIsValid;
    }

    function validateAddTaxRate() {
        let formIsValid = false;
        const taxRateStr = String(adddata.taxRate);  // Convert to string

        if (!taxRateStr) {
            seterrorTaxRate("*Enter tax rate.");
        } else if (!/^\d{1,3}$/.test(taxRateStr)) {
            seterrorTaxRate("*Enter valid tax rate (1 to 3 digits).");
        } else {
            formIsValid = true;
            seterrorTaxRate("");
        }

        return formIsValid;
    }

    function validateAddCategory() {
        let formIsValid = false;
        if (!adddata.category) {
            formIsValid = false;
            seterrorCategory("*Enter Category.");
        } else {
            formIsValid = true;
            seterrorCategory("");
        }
        return formIsValid;
    }

    function validateAddDescription() {
        let formIsValid = false;
        if (!adddata.description) {
            formIsValid = false;
            seterrorDescription("*Enter Description.");
        } else {
            formIsValid = true;
            seterrorDescription("");
        }
        return formIsValid;
    }

    function validateAddForm() {
        let hsn = validateAddHSN(); let cutoff = validateAddCutOff(); let taxRate = validateAddTaxRate(); let category = validateAddCategory(); let description = validateAddDescription();
        let valid = hsn && cutoff && taxRate && category && description;
        if (!valid) {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Please fill all the required fields correctly.",
            });
        }
        return valid;
    }

    // Function to handle individual checkbox change
    const handleCheckboxChange = (id) => {
        console.log("Checkbox clicked:", id);
        const updatedCheckboxes = selectedCheckboxes.includes(id)
            ? selectedCheckboxes.filter((checkboxId) => checkboxId !== id)
            : [...selectedCheckboxes, id];
        setSelectedCheckboxes(updatedCheckboxes);
    };

    const Checkbox = ({ id, isChecked, onChange, name, value }) => (
        <input type="checkbox" name={name} value={value} id={id} checked={isChecked} onChange={() => onChange(id)} />
    );

    // Function to handle "Select All" checkbox change
    const handleSelectAllChange = () => {
        const allCheckboxIds = filter.map((item) => item.cartId);
        setSelectedCheckboxes((prevSelected) =>
            prevSelected.length === allCheckboxIds.length ? [] : allCheckboxIds
        );
    };

    const onchangeeditdata = (event) => {
        seteditdata((editdata) => ({
            ...editdata,
            [event.target.name]: event.target.value,
        }));
    };

    const onchangeadddata = (event) => {
        setadddata((adddata) => ({
            ...adddata,
            [event.target.name]: event.target.value,
        }));
    };

    const addtoggle = () => setaddModal(!addmodal);

    const saveaddtoggle = (e) => {
        e.preventDefault();
        if (validateAddForm()) {
            props.requestStoreSave({
                data: {
                    userToken: logindetails.data.userToken,
                    //      compToken: localStorage.getItem('companyToken'),
                    compToken: '611337539322',
                    category: adddata.category,
                    description: adddata.description,
                    quantity: adddata.quantity,
                    freeQty: adddata.freeQty,
                    shortName: adddata.shortName,
                    hsn: adddata.hsn,
                    warranty: adddata.warranty,
                    taxRate: adddata.taxRate
                },
            });
            setadddata({
                category: "", description: "", quantity: 0, freeQty: 0, barcode: "", hsn: "", warranty: 0, taxRate: 0
            });
            addtoggle();
        }
    };

    useEffect(() => {
        let addData = props.data.storeSaveData;
        if (addData !== undefined) {
            if (addData.data.status === 1) {
                console.log(addData.data.status);
                Swal.fire({
                    title: "Good job!",
                    text: addData.data.message,
                    icon: "success",
                });
                setchange(!change);
            }
        }
        props.data.storeSaveData = undefined;
        addData = undefined;
    }, [props.data.storeSaveData]);

    const edittoggle = (id) => {
        if (editmodal === true) {
            seteditmodal(!editmodal);
        } else {
            seteditmodal(!editmodal);
            setid(id);
            console.log(logindetails.data.userToken);
            props.requestGetStoreById({
                data: {
                    param2: id.toString(),
                    param1: '611337539322', //localStorage.getItem('companyToken')
                    token: logindetails.data.userToken
                },
            });
        }
    };

    useEffect(() => {
        let itemData = props.data.storeByIdData;
        console.log(itemData);
        if (itemData !== undefined) {
            if (itemData.data) {
                seteditdata(itemData.data.data);
            }
        }
    }, [props.data.storeByIdData]);

    const saveedittoggle = (e) => {
        e.preventDefault();
        if (validateEditForm()) {
            props.requestStoreUpdate({
                data: {
                    id: id,
                    userToken: logindetails.data.userToken,
                    //      compToken: localStorage.getItem('companyToken'),
                    compToken: '611337539322',
                    category: editdata.category,
                    description: editdata.description,
                    quantity: editdata.quantity,
                    freeQty: editdata.freeQty,
                    shortName: editdata.shortName,
                    hsn: editdata.hsn,
                    warranty: editdata.warranty,
                    taxRate: editdata.taxRate,
                    cutOff: editdata.cutOff
                },
            });
            seteditdata({
                category: "", description: "", quantity: 0, freeQty: 0, barcode: "", hsn: "", warranty: 0, taxRate: 0, cutOff: 0
            });
            setid(0);
            edittoggle();
        }
    }

    useEffect(() => {
        let statusJobData = props.data.storeUpdateData;
        if (statusJobData !== undefined) {
            if (statusJobData?.data?.status == 1) {
                Swal.fire(
                    "Good job!",
                    statusJobData?.data?.message,
                    "success"
                );
                props.data.storeUpdateData = undefined;
                statusJobData = undefined;
                setchange(!change);
            } else {
                Swal.fire("Error!", `${statusJobData.data.message}`, "error");
                props.data.storeUpdateData = undefined;
            }
        }
    }, [props.data.storeUpdateData]);

    const handleSearch = (event) => {
        console.log(event.target.value);
        setSearch(event.target.value);
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0'); // Ensures 2 digits
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = date.getFullYear();

        return `${day} / ${month} / ${year}`;
    };

    const conditionalRowStyles = [
        {
            when: row => row.razorpayStatus === 'paid',
            style: {
                backgroundColor: '#d4edda', // light green
                color: '#155724',           // dark green text
                fontWeight: 'bold'
            }
        }
    ];

    const columns = [
        {
            name: 'Select',
            cell: item => <div>
                <Checkbox id={item.Id} name="select" value={item.Id} onChange={() => handleCheckboxChange(item.Id)} isChecked={selectedCheckboxes.includes(item.Id)}></Checkbox>
            </div>,
            selector: item => item.Id,
            width: '1%'
        },
        {
            name: 'Category',
            cell: item => <div><h6>{item.category}</h6></div>,
            selector: item => item.category,
            width: '15%'
        },
        {
            name: 'Description',
            cell: item => <div><h6>{item.description}</h6></div>,
            selector: item => item.description,
            width: '15%'
        },
        {
            name: 'Qty',
            cell: item => <div><h6>{item.quantity}</h6></div>,
            selector: item => item.quantity,
            width: '10%'
        },
        {
            name: 'Tax',
            cell: item => <div><h6>{item.taxRate}</h6></div>,
            selector: item => item.taxRate,
            width: '5%'
        },
        {
            name: 'ShortName',
            cell: item => <div><h6>{item.shortName}</h6></div>,
            selector: item => item.shortName,
            width: '10%'
        },
        {
            name: 'Cut Off',
            cell: item => <div><h6>{item.cutOff}</h6></div>,
            selector: item => item.cutOff,
            width: '10%'
        },
        {
            name: 'HSN Code',
            cell: item => <div><h6>{item.hsn}</h6></div>,
            selector: item => item.hsn,
            width: '10%'
        },
        {
            name: 'Action',
            cell: item => <div>
                <button class="badge badge-opacity-warning" style={{ border: "0px", marginLeft: "5px", }}
                    onClick={() => { edittoggle(item.id); }}><i className="fa fa-edit"></i></button>
                {editmodal === true && (
                    <Modal
                        isOpen={editmodal}
                        toggle={edittoggle}
                    >
                        <ModalHeader toggle={edittoggle}>
                            Update Product
                        </ModalHeader>
                        <ModalBody>
                            <form class="forms-sample">
                                <div class="form-group">
                                    <label>Category</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Category"
                                        name="category"
                                        value={editdata.category}
                                        onBlur={validateEditCategory}
                                        onChange={onchangeeditdata}
                                    />
                                    {errorCategory && <p>{errorCategory}</p>}
                                </div>
                                <div class="form-group">
                                    <label>Short Name</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="ShortName"
                                        name="shortName"
                                        value={editdata.shortName}
                                        onChange={onchangeeditdata}
                                    />
                                </div>
                                <div class="form-group">
                                    <label>Description</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Description"
                                        name="description"
                                        value={editdata.description}
                                        onBlur={validateEditDescription}
                                        onChange={onchangeeditdata}
                                    />
                                    {errorDescription && <p>{errorDescription}</p>}
                                </div>
                                <div class="form-group">
                                    <label>Tax Rate</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Tax Rate"
                                        name="taxRate"
                                        value={editdata.taxRate}
                                        onBlur={validateEditTaxRate}
                                        onChange={onchangeeditdata}
                                    />
                                    {errorTaxRate && <p>{errorTaxRate}</p>}
                                </div>
                                <div class="form-group">
                                    <label>Cut Off</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Cut Off"
                                        name="cutOff"
                                        value={editdata.cutOff}
                                        onBlur={validateEditCutOff}
                                        onChange={onchangeeditdata}
                                    />
                                    {errorCutOff && <p>{errorCutOff}</p>}
                                </div>
                                <div class="form-group">
                                    <label>HSN</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="hsn"
                                        name="hsn"
                                        value={editdata.hsn}
                                        onBlur={validateEditHSN}
                                        onChange={onchangeeditdata}
                                    />
                                    {errorHSN && <p>{errorHSN}</p>}
                                </div>
                                <button
                                    type="submit" class="btn btn-primary me-2" onClick={saveedittoggle} >
                                    Update
                                </button>
                                <button
                                    class="btn btn-light"
                                    onClick={edittoggle}
                                >
                                    Cancel
                                </button>
                            </form>
                        </ModalBody>
                    </Modal>
                )}
                <button class="badge badge-opacity-danger" style={{ border: "0px", background: "#fea8a9", marginLeft: "5px", }}
                    onClick={() => { deletedata(item.id); }}><i class="fa fa-trash"></i></button>
            </div>,
            selector: item => item.id,
            width: '100px'
        },
    ];

    function deletedata(id) {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                props.requestStoreDelete({
                    data: {
                        token: logindetails.data.userToken,
                        param1: id.toString()
                    },
                });
            }
        })
    }

    //delete
    useEffect(() => {
        let deleteData = props.data.storeDeleteData;
        if (deleteData !== undefined) {
            if (deleteData.data.status === 1) {
                Swal.fire({
                    title: 'Good job!',
                    text: deleteData.data.message,
                    icon: 'success'
                });
                setchange(!change)
            }
            else{
                Swal.fire({
                    title: 'Error!',
                    text: deleteData.data.message,
                    icon: 'error'
                })
            }
        }
        props.data.storeDeleteData = undefined;
        deleteData = undefined;
    }, [props.data.storeDeleteData]);

    useEffect(() => {
        let data1 = JSON.parse(localStorage.getItem("user"));
        if (data1) {
            setlogindetails(data1);
            props.requestStoreList({
                //      token: localStorage.getItem('companyToken'),
                token: '611337539322',
                page: params.page,
                page_size: params.page_size,
                search: 'a'
            });
        }
        setpage_size(params.page_size);
    }, [params.page, params.page_size, change]);

    function onChangePageSize(e) {
        setpage_size(e.target.value);
        if (e.target.value > 0) {
            navigate(`/storelist/1/${e.target.value}`);
        }
    }

    //set job list
    useEffect(() => {
        let jobsData = props.data.storeListData;
        console.log(jobsData);
        if (jobsData !== undefined) {
            if (jobsData.data) {
                setjobs(jobsData.data.data);
                setFilter(jobsData.data.data);
                // setTotalRows(jobsData.data.meta.total);
            }
        }
    }, [props.data.storeListData]);

    const handlePageChange = page => {
        console.log(page);
        props.requestStoreList({
            page: page,
            page_size: page_size,
            search: 'a'
        });
    }

    const handlePerRowsChange = async (newPerPage, page) => {
        setpage_size(newPerPage);
        props.requestStoreList({
            page: page,
            page_size: newPerPage,
            search: 'a'
        });
    }

    function printPage() {
        var printContents = "<br/><center><h3>Jobs</h3></center>" + document.getElementById("printme").innerHTML;
        var originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
    }

    function HandleAddProduct() {

    }

    const tableHeaderStyle = {
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "14px"
            },
        },
    }

    return (
        <>
            <div class="container-scroller">
                {/* <PageHeader name="Jobs" /> */}
                <div class="container-fluid page-body-wrapper">
                    <Sidebar name="Jobs" />
                    <div class="main-panel">
                        <div class="content-wrapper">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="home-tab">
                                        <div class="row flex-grow">
                                            <div class="col-12 grid-margin stretch-card">
                                                <div class="card card-rounded">
                                                    <div class="card-body">
                                                        <div class="d-sm-flex justify-content-between align-items-start">
                                                            <div class="btn-wrapper">
                                                                <RWebShare
                                                                    data={{
                                                                        text: "BookkeeperDay - Your Personal Bookkeeping App",
                                                                        url: `${baseUrl}/cart/${params.page}/${params.page_size}`,
                                                                        title: "Cart List",
                                                                    }}
                                                                >
                                                                    <p class="btn btn-otline-dark align-items-center"><i class="icon-share"></i> Share</p>
                                                                </RWebShare>
                                                                <button onClick={printPage} class="btn btn-otline-dark"><i class="icon-printer"></i> Print</button>
                                                            </div>
                                                        </div>
                                                        <div class="card">
                                                            <div class="card-body">
                                                                <button class="btn btn-primary" style={{ color: '#fff' }} onClick={addtoggle}>Add Item</button>
                                                                {addmodal === true && (
                                                                    <Modal
                                                                        isOpen={addmodal}
                                                                        toggle={addtoggle}
                                                                    >
                                                                        <ModalHeader toggle={addtoggle}>
                                                                            Update Product
                                                                        </ModalHeader>
                                                                        <ModalBody>
                                                                            <form class="forms-sample">
                                                                                <div class="form-group">
                                                                                    <label>Category</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        class="form-control"
                                                                                        placeholder="Category"
                                                                                        name="category"
                                                                                        value={adddata.category}
                                                                                        onBlur={validateAddCategory}
                                                                                        onChange={onchangeadddata}
                                                                                    />
                                                                                    {errorCategory && <p>{errorCategory}</p>}
                                                                                </div>
                                                                                <div class="form-group">
                                                                                    <label>Short Name</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        class="form-control"
                                                                                        placeholder="ShortName"
                                                                                        name="shortName"
                                                                                        value={adddata.shortName}
                                                                                        onChange={onchangeadddata}
                                                                                    />
                                                                                </div>
                                                                                <div class="form-group">
                                                                                    <label>Description</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        class="form-control"
                                                                                        placeholder="Description"
                                                                                        name="description"
                                                                                        value={adddata.description}
                                                                                        onBlur={validateAddDescription}
                                                                                        onChange={onchangeadddata}
                                                                                    />
                                                                                    {errorDescription && <p>{errorDescription}</p>}
                                                                                </div>
                                                                                <div class="form-group">
                                                                                    <label>Tax Rate</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        class="form-control"
                                                                                        placeholder="Tax Rate"
                                                                                        name="taxRate"
                                                                                        value={adddata.taxRate}
                                                                                        onBlur={validateAddTaxRate}
                                                                                        onChange={onchangeadddata}
                                                                                    />
                                                                                    {errorTaxRate && <p>{errorTaxRate}</p>}
                                                                                </div>
                                                                                <div class="form-group">
                                                                                    <label>Cut Off</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        class="form-control"
                                                                                        placeholder="Cut Off"
                                                                                        name="cutOff"
                                                                                        value={adddata.cutOff}
                                                                                        onBlur={validateAddCutOff}
                                                                                        onChange={onchangeadddata}
                                                                                    />
                                                                                    {errorCutOff && <p>{errorCutOff}</p>}
                                                                                </div>
                                                                                <div class="form-group">
                                                                                    <label>HSN</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        class="form-control"
                                                                                        placeholder="hsn"
                                                                                        name="hsn"
                                                                                        value={adddata.hsn}
                                                                                        onBlur={validateAddHSN}
                                                                                        onChange={onchangeadddata}
                                                                                    />
                                                                                    {errorHSN && <p>{errorHSN}</p>}
                                                                                </div>
                                                                                <button
                                                                                    type="submit" class="btn btn-primary me-2" onClick={saveaddtoggle} >
                                                                                    Save
                                                                                </button>
                                                                                <button
                                                                                    class="btn btn-light"
                                                                                    onClick={addtoggle}
                                                                                >
                                                                                    Cancel
                                                                                </button>
                                                                            </form>
                                                                        </ModalBody>
                                                                    </Modal>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div class="table-responsive  mt-1" id="printme">
                                                            <DataTable
                                                                columns={columns}
                                                                data={filter}
                                                                pagination
                                                                paginationServer
                                                                paginationTotalRows={totalRows}
                                                                onChangePage={handlePageChange}
                                                                onChangeRowsPerPage={handlePerRowsChange}
                                                                actions={<button className="btn btn-success">Export to PDF</button>}
                                                                subHeader
                                                                subHeaderComponent={
                                                                    <input id="search" type="text" className="w-25 form-control" placeholder="Search..." value={search} onChange={handleSearch} />
                                                                }
                                                                customStyles={tableHeaderStyle}
                                                                conditionalRowStyles={conditionalRowStyles}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <Footer /> */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return { data: state.data };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ requestStoreList, requestStoreSave, requestGetStoreById, requestStoreUpdate, requestStoreDelete }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(StoreList);